import React, { Component } from 'react';
import mergeStyles from '../utils/StyleMerge';
import withSizes from '../utils/Sizes';

class Section extends Component {
  render() {
    const {
      children,
      styles,
      getStyle
    } = this.props;
    return (
      /*#__PURE__*/
      React.createElement("div", {
        style: getStyle(styles.container)
      }, children)
    );
  }

}

const defaultStyles = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    xs: {},
    sm: {},
    md: {},
    lg: {},
    xl: {}
  }
};
Section.defaultProps = {
  children: null,
  isMobile: false
};
export default mergeStyles(defaultStyles)(withSizes(Section));